import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import {
  TableHeader,
  SearchInput,
  IconButtonDatatable,
  DatatablesFooterServerSide,
  Loading,
} from "App/Component/ui";
import { headCells, ModalBarang, STYLE_WMS_PO } from "./helpers";

import {
  convertToValidPrice,
  defaultToastError,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { SelectIcon } from "App/Assets";
import { useContext } from "react";
import { FormContext } from "../../context/FormContext";
import {
  getByFilterBarang,
  RESET_STATE_FORM_FILTER,
} from "../../../../Master/MasterBarang/ui";
import { STATUS_OPEN_DRAFT_PEMBELIAN } from "../../helpers";

export default function DataBarang({
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  setNewDataPembelianList,
}) {
  const classes = STYLE_WMS_PO();
  const { formData } = useContext(FormContext);
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  useEffect(() => {
    (async () => {
      await setNewDataBarang();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataBarang = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);
    const res = await getByFilterBarang(formFilter, pages, limit, true);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataBarang });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewDataBarang();
  };

  const handleClickSelectBarang = (row) => {
    setShowModalBarang(!showModalBarang);
    setFormBarang({
      id: "",
      name: row?.name,
      pembelian_id: formData.id,
      barang_id: row?.id,
      satuan_id: row?.satuanbeli_id,
      satuanjual_id: row?.satuanjual_id,
      harga: row.hargabeli * row.qjb,
      harga2: formatNumber(row.hargabeli * row.qjb),
      qty: 1,
      disc: 0,
      nilai_disc: 0,
      qjb: row.qjb,
      hargaqjbhpp: convertToValidPrice(row.hargabeli / row.qjb),
      nobatch: "",
      sub_total: formatNumber(row.qty * row.hargabeli),
      exired_date: "",
      is_proses: true,
      is_po_proses: false,
      remark: "-",
    });
  };
  return (
    <>
      {showModalBarang && (
        <ModalBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      )}
      <div
        style={{
          opacity: `${formData.is_po ? "0.5" : "1"}`,
        }}>
        <div className={classes.header}>
          <div>
            <p className='fw-600 mb-1 mt-1'>Data Barang</p>
          </div>
          <div
            style={{
              display: "flex",
              gap: "0 10px",
            }}>
            <form onSubmit={(e) => handleSubmit(e)}>
              <SearchInput
                withIcon={true}
                onchange={(e) => {
                  setFormFilter({
                    ...formFilter,
                    nama: e.target.value,
                  });
                }}
              />
            </form>
          </div>
        </div>
        <Loading show={loading} />
        <TableDaftarBarang
          rows={rows}
          classes={classes}
          formData={formData}
          handleClickSelectBarang={handleClickSelectBarang}
        />
        <DatatablesFooterServerSide
          totalData={totalData}
          pagination={pagination}
          handleChangeLimit={handleChangeLimit}
          onPrevious={onPrevious}
          onNext={onNext}
          currentPage={pagination.page}
          handleClickPageNumber={handleClickPageNumber}
        />
      </div>
    </>
  );
}

const RenderTableCell = ({ row }) => {
  return (
    <>
      <TableCell align='left'>{row.name}</TableCell>
      <TableCell align='left'>{row.satuan_beli}</TableCell>
      <TableCell align='left'>{row.qjb}</TableCell>
      <TableCell align='right'>{formatNumber(row?.hargabeli)}</TableCell>
    </>
  );
};

const TableDaftarBarang = ({
  rows,
  classes,
  handleClickSelectBarang,
  formData,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });
  return (
    <TableContainer
      className='custom-scrollbar'
      style={{
        maxHeight: "400px",
      }}>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {rows.map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <IconButtonDatatable
                    onClick={() => {
                      if (isNull(formData.po_id)) {
                        if (formData.status === STATUS_OPEN_DRAFT_PEMBELIAN) {
                          handleClickSelectBarang(row);
                        } else {
                          return;
                        }
                      } else {
                        return;
                      }
                    }}>
                    <SelectIcon />
                  </IconButtonDatatable>
                </TableCell>
                <RenderTableCell row={row} />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
